module.exports = __webpack_public_path__ + "static/media/badge6.f9358522.svg";